import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Icon } from './icon.model';

@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'emm-icon',
    styleUrls: ['./icon.component.scss'],
    template: ''
})
export class IconComponent {

    @Input() symbol: Icon;

    constructor() {}

}
